import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch'

//import VueGoodTablePlugin from 'vue-good-table';

// import the styles
//import 'vue-good-table/dist/vue-good-table.css'

import './assets/scss/app.scss'
import './assets/scss/default/_variable.scss'

import {InlineSvgPlugin} from 'vue-inline-svg';
Vue.use(InlineSvgPlugin);

import Pagination from 'vue-pagination-2';
Vue.component( 'pagination', Pagination );

//Vue.use(VueGoodTablePlugin);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')

/**

plugins: [
  '~/plugins/vue-awesome-swiper.js',
  '~/plugins/vue-cool-lightbox.js',
  '~/plugins/vue2-google-maps.js',
  '~/plugins/vue-pagination.js',
  '~/plugins/vue-inline-svg.js',
  '~/plugins/observe-visibility.js',
  '~/plugins/vue-masonry-css.js',
  { 
      src: '~/plugins/bootstrap.bundle.min.js', 
      mode: 'client'
  },
  { 
      src: "~/plugins/aos", 
      ssr: false 
  }
],

**/